import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-title",
  standalone: true,
  imports: [TranslatePipe, CommonModule],
  templateUrl: "./title.component.html",
  styleUrl: "./title.component.css",
})
export class TitleComponent {
  @Input()
  title!: string;

  @Input()
  text!: string;
}
